export default __webpack_public_path__ + "static/media/ic_package1.eea5c5d1.svg";